import { render, staticRenderFns } from "./PixelsTable.vue?vue&type=template&id=5de48009&"
import script from "./PixelsTable.vue?vue&type=script&lang=js&"
export * from "./PixelsTable.vue?vue&type=script&lang=js&"
import style0 from "./PixelsTable.vue?vue&type=style&index=0&id=5de48009&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports